import { AxiosError } from "axios";
import { useQuery, useQueryClient, UseQueryOptions } from "react-query";

import axios from "utilities/axios";

const getData = async <T extends {}>(url: string) => {
    const { data } = await axios.get<T | { items: T }>(url);
    if ("items" in data) {
        return data.items;
    } else {
        return data;
    }
};

export const useSimplePrefetch = async (url: string) => {
    const queryClient = useQueryClient();
    queryClient.prefetchQuery(url, () => getData(url));
};

const useSimpleQuery = <T extends {}, P = T>(url: string, configuration: UseQueryOptions<T, AxiosError, P> = {}) => {
    return useQuery<T, AxiosError, P>(url, () => getData<T>(url), configuration);
};

export default useSimpleQuery;
